import { LocalStorageConsts, LoginModalConsts } from 'client/util/Constants';
import Cookies from 'js-cookie';
import DateUtil from 'client/util/DateUtil';

const {
  loginModalSeen,
} = LocalStorageConsts;
const {
  excludeModalTestingCookie,
} = LoginModalConsts;

/**
 * @param {Object} config Configuaration object
 * {
 *  name: 'modalName',
 *  component: modalComponent, // imported Vue component
 *  startDate: '2020-06-25',
 *  endDate: '2020-07-08',
 *  preventCloseOnOverlayClick: false,
 *  isLargeModal: false,
 *  isMediumModal: false,
 *  isFullScreenModal: false,
 *  excludeTesting: true,
 *  localStorageKey: universityModalSeen, // imported LocalStorageConst
 *  modalVisibility: () => true, // function for custom visibility logic that returns boolean
 * }
 */
export function LoginModalConfig(params = {}) {
  const defaultModalVisibility = () => false;
  this.modalVisibility = params.modalVisibility || defaultModalVisibility;
  this.name = params.name;
  this.component = params.component;
  this.startDate = params.startDate;
  this.endDate = params.endDate;
  this.localStorageKey = params.localStorageKey || loginModalSeen;
  this.preventCloseOnOverlayClick = params.preventCloseOnOverlayClick || false;
  this.isLargeModal = params.isLargeModal || false;
  this.isMediumModal = params.isMediumModal || false;
  this.isFullScreenModal = params.isFullScreenModal || false;
  this.excludeTesting = params.excludeTesting || true;
}

export function LoginModal(config = new LoginModalConfig()) {
  this.name = config.name;
  this.component = config.component;
  this.startDate = config.startDate;
  this.endDate = config.endDate;
  this.preventCloseOnOverlayClick = config.preventCloseOnOverlayClick;
  this.isLargeModal = config.isLargeModal;
  this.isMediumModal = config.isMediumModal;
  this.isFullScreenModal = config.isFullScreenModal;

  this.modalSeen = !!localStorage.getItem(config.localStorageKey);
  this.isCurrentModal = DateUtil.isInDateRange(config.startDate, config.endDate);
  this.modalVisibility = config.modalVisibility;
  this.excludeTesting = config.excludeTesting && !!Cookies.get(excludeModalTestingCookie);
  const shouldShowModal = this.isCurrentModal
    && !this.excludeTesting
    && !this.modalSeen
    && this.modalVisibility();

  this.showModal = shouldShowModal;
  this.payload = {
    component: this.component,
    preventCloseOnOverlayClick: this.preventCloseOnOverlayClick,
    isLargeModal: this.isLargeModal,
    isMediumModal: this.isMediumModal,
    isFullScreenModal: this.isFullScreenModal,
  };
  return this;
}
